export const formatEventToActivationFormat = (data: CriticalEvent) => {
  const transformSingleEvent = (event: CriticalEventRule) => {
    // Format mapping_rules to convert 'equals' to 'eq'
    const formattedMappingRules = event.mapping_rules.map((andRules) =>
      andRules.map((rule) => ({
        tag_key: {
          op: rule.tag_key.op === 'equals' ? 'eq' : rule.tag_key.op,
          value: rule.tag_key.value,
        },
        tag_value: {
          op: rule.tag_value.op === 'equals' ? 'eq' : rule.tag_value.op,
          value: rule.tag_value.value,
        },
      })),
    );

    return {
      key: 'all_event_name',
      op: 'eq',
      value: event.value,
      mapping_rules: formattedMappingRules,
    };
  };

  return {
    event_name: data.name,
    event_category: 'Custom',
    rules: [data.rules.map((event) => transformSingleEvent(event?.[0]))],
  };
};
